import { createFileRoute, redirect } from '@tanstack/react-router';

// The full-screen Clu chat moved to /clu with the Copilot -> Clu rename.
// This stays as a redirect so bookmarks, emails and deep links to /copilot
// keep working, with their query string and hash carried over.
export const Route = createFileRoute('/copilot')({
  beforeLoad: ({ location }) => {
    throw redirect({
      to: '/clu',
      search: location.search,
      hash: location.hash,
      replace: true,
    });
  },
});
